<h3 class="mb-5">Public Elements - {{ this.category.display }}</h3>
<ngx-folders
  #folders
  [delegate]="this"
  [settings]="settings"
  [selectMode]="true"
  mode="submit"
  (itemSelected)="selectedElementEvent.emit($event)"
>
  <ng-template folder-item-tmp let-item="item">
    <div class="flex flex-col aspect-square">
      <div
        class="flex items-center justify-center h-full w-full p-4 rounded-lg bg-slate-100 shadow-sm text-center cursor-pointer"
      >
        @if (item.thumbnail != null) {
          <div class="h-full w-full">
            <img
              class="aspect-square h-full w-full rounded object-contain object-center"
              [src]="item.thumbnail"
            />
          </div>
        }
        @if (item.thumbnail == null) {
          <div class="bg-gray-300 rounded"></div>
        }
      </div>

      <div>
        <h3 class="text-xs font-medium text-gray-900 pl-1 pt-2 pr-4">
          {{ item.name }}
        </h3>
      </div>
    </div>
  </ng-template>
</ngx-folders>

<div class="flex items-center justify-center col-span-6">
  <confect-loading [loading]="folders == null || folders?.openingFolder" />
</div>
